module.exports = __webpack_public_path__ + "img/飞猪.43aad4b1.jpg";